import React from 'react'

import { Paper } from '@mui/material'

interface PaperPanelProps {
  centerText?: boolean
  elevation?: number
  children?: React.ReactNode
}

export const PaperPanel: React.FC<PaperPanelProps> = ({
  children,
  centerText,
  elevation = 3
}) => {
  return (
    <Paper
      elevation={elevation}
      style={{ padding: '20px', textAlign: centerText ? 'center' : 'left' }}
    >
      {children}
    </Paper>
  )
}
